import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PSpinnerComponent } from './p-spinner.component';

@NgModule({
    declarations: [PSpinnerComponent],
    imports: [CommonModule],
    exports: [PSpinnerComponent]
})
export class PSpinnerModule {}
